import {mapState} from "vuex";

export default {
  name: "TenantsList",
  props: {
    show: {
      type: Boolean,
      default: () => {
      }
    },
    hide: {
      type: Function,
      default: () => {
      }
    },
    onSelectItem: {
      type: Function,
      default: () => {
      }
    },
    items: {
      type: Array,
      default: []
    },
    user: {
      type: Object,
      default: () => {
      }
    },
    onInactive: {
      type: Function,
      default: () => {
      }
    }
  },
  data: () => ({
    localItems: []
  }),
  watch: {
    items: {
      handler() {
        this.initLocalItems();
      },
      deep: true
    },
    show(val) {
      if (val) {
        for (const item of this.localItems) {
          item.selected = false;
          if (item.tenant_id === this.tenant_id) {
            item.selected = true;
          }
        }
      }
    }
  },
  components: {},
  computed: {
    ...mapState({
      tenant_id: state => state.Chat.tenant_id
    })
  },
  created() {
    this.initLocalItems();
  },
  methods: {
    initLocalItems() {
      this.localItems = [];
      for (const item of this.items) {
        this.localItems.push({
          ...item,
          selected: item.tenant_id === this.tenant_id
        })
      }
    },
    close: function () {
      this.hide();
    },
    selectItem(index) {
      const updated = this.localItems.map((item, i) => ({
        ...item,
        selected: i === index
      }));
      this.localItems = updated;
    },
    confirmItem() {
      const self = this;
      const selectedItem = this.localItems.find(x => x.selected);
      if (selectedItem || this.localItems.length === 0) {

        let inactiveAccontExist = Object.values(this.user.tenants_list)
          .find(
            x => x.tenant_id === selectedItem.tenant_id &&
              x.role !== selectedItem.role &&
              x.status === 'inactive'
          );

        if (inactiveAccontExist) {
          self.onInactive({inactive: inactiveAccontExist, active: selectedItem});
        } else {
          this.onSelectItem(selectedItem);
          this.hide();
        }
      }
    }
  },
};